import { GpsDataType } from 'app/constants/gpsDataType'

export const getGpsDataTypeName = (
  gpsDataType: GpsDataType,
  translate: (string) => string,
): string => {
  const text: string = GpsDataType[gpsDataType]
  return translate(`gpsDataType.${text}`)
}
